import React from 'react';
import Modal from 'react-responsive-modal';

export default class ModalResponsive extends React.Component{
    render() {     
        return (
            <div>
                <Modal open={this.props.open} showCloseIcon={(this.props.ocultarClose!==undefined?false:true)} 
                    onClose={this.props.onClose} little={(this.props.little===undefined?true:false)} 
                    closeOnOverlayClick={(this.props.closeOut)?this.props.closeOut:false} closeOnEsc={false} closeIconSize={20}>
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}